import { DexieError } from "dexie"

import { logger } from "@/utils/monitoring/logging"
import { captureException } from "@/utils/monitoring/monitoring"
import { stringifyError } from "@/utils/types"

function isAbortError(error: unknown): error is DexieError {
  if (error instanceof Error) {
    const e = error as DexieError | undefined
    return e?.name === "AbortError" || e?.inner?.name === "AbortError"
  }

  return false
}

export function logDexieError(error: unknown) {
  logger.warn("dexie error", { error: stringifyError(error) })

  if (isAbortError(error)) {
    if (error.inner) {
      logger.warn("AbortError inner error", {
        error: stringifyError(error),
        innerError: stringifyError(error.inner),
      })
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    error.cause = error.inner
    captureException(error)
  } else {
    captureException(error)
  }
}
